import { render, staticRenderFns } from "./detailTitle.vue?vue&type=template&id=3ba1e3f9&scoped=true&"
import script from "./detailTitle.vue?vue&type=script&lang=js&"
export * from "./detailTitle.vue?vue&type=script&lang=js&"
import style0 from "./detailTitle.vue?vue&type=style&index=0&id=3ba1e3f9&lang=less&rel=stylesheet%2Fless&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba1e3f9",
  null
  
)

export default component.exports